/**
 * Converts a URL slug to a human-readable title.
 * e.g. "the-red-lion-pub" → "The Red Lion Pub"
 */
export function slugToTitle(slug: string): string {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
